import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Divider } from 'antd'

import { logout } from '../../containers/Authentication/services'
import { userLogout } from '../../containers/Authentication/actions'
import { handleError } from '../../helpers'

export default function MainMenu({ closeMenu }) {
	const user = useSelector(state => state.auth.user)
	const dispatch = useDispatch()

	const onLogout = () => {
		logout()
			.then(() => dispatch(userLogout()))
			.catch(handleError)
	}

	const MenuLink = ({ to, label }) => (
		<li>
			<Link to={to} onClick={closeMenu}>
				{label}
			</Link>
		</li>
	)

	return (
		<React.Fragment>
			<Container>
				<UserContainer>
					<UserName>{user.name}</UserName>
					<p>c.c. {user.document}</p>
					<p className="mb-0 text-link" onClick={onLogout}>Cerrar Sesión</p>
				</UserContainer>
				<MenuList>
					<MenuLink to="/services" label="Servicios Programados" />
					<MenuLink to="/service_reviews" label="Diagnósticos de Servicio" />
					<MenuLink to="/service_reports" label="Reportes de Servicio" />
					<MenuLink to="/service_results" label="Informes de Servicio" />
					<MenuLink to="/certificates" label="Certificaciones" />
					
					<Divider className='mt-15 mb-0' />

					{ (user.role === 'admin' || user.permissions.includes('view_companies')) && (
						<React.Fragment>
							<MenuLink to="/companies" label="Clientes y Proveedores" />
							<MenuLink to="/employees" label="Directorio Contactos Cliente" />
							<MenuLink to="/locations" label="Directorio Sedes de Clientes" />
						</React.Fragment>
					)}

					{ (user.role === 'admin' || user.permissions.includes('view_technicians')) && (
						<MenuLink to="/technicians" label="Directorio de Técnicos" />
					)}
					
					{ (user.role === 'admin' || user.permissions.includes('view_vehicles')) && (
						<MenuLink to="/vehicles" label="Directorio de Vehículos" />
					)}

					<Divider className='mt-15 mb-0' />

					{ (user.role === 'admin' || user.permissions.includes('view_reports')) && (
						<MenuLink to="/reports" label="Reportes Administradores" />
					)}

					{ (user.role === 'admin' || user.permissions.includes('view_users')) && (
						<MenuLink to="/users" label="Usuarios Administradores" />
					)}

					{ user.role === 'admin' && (
						<MenuLink to="/item_types" label="Administrar Productos y Servicios" />
					)}
				</MenuList>
				<p>Correo de soporte: soporte@smart4.com.co</p>
			</Container>
		</React.Fragment>
	)
}

const Container = styled.div`
	position: fixed;
	top: 0px;
	left: 0px;
	height: 100vh;
	z-index: 9;	
	padding-top: 50px;
	width: 250px;
	background-color: white;
	text-align: center;
	-webkit-box-shadow: 3px 0 12px 0 #b3b3b3;
	box-shadow: 3px 0 12px 0 #b3b3b3;
	overflow-y: scroll;
`

const UserContainer = styled.div`
	padding: 40px 20px 30px;
	background-color: #e8e8e8;
`

const UserName = styled.h6`
	font-size: 17px;
	text-transform: uppercase;
	font-weight: 600;
	margin-bottom: 3px;
	margin-top: 10px;
`

const MenuList = styled.ul`
	list-style: none;
	margin: 0px 0px 30px;
	padding: 0;
	& li {
		padding: 0;
    	margin: 0;
	}
	& li a {
		display: inline-block;
		padding: 14px 0;
		margin: 0;
		border-bottom: 1px solid #e8e8e8;
		width: 100%;
	}
	& li a:hover {
		cursor: pointer;
		background-color: #12628d;
		color: #fff !important;
	}
`